import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import NewLoan from '@/pages/NewLoan.vue'

import Loans from '@/pages/Loans.vue'
import LoansView from '@/pages/Loans/View.vue'
import LoansDetail from '@/pages/Loans/Detail.vue'
import LoansEdit from '@/pages/Loans/Edit.vue'
import LoansAddPrincipal from '@/pages/Loans/AddPrincipal.vue'
import LoansEditPayment from '@/pages/Loans/EditPayment.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'
import ClientsEdit from '@/pages/Clients/Edit.vue'

import Transactions from '@/pages/Transactions.vue'
import TransactionsView from '@/pages/Transactions/View.vue'


import Projects from '@/pages/Projects.vue'
import ProjectsView from '@/pages/Projects/View.vue'
import ProjectsEdit from '@/pages/Projects/Edit.vue'

import PrintLoan from '@/pages/PrintLoan.vue'
import PrintReceipt from '@/pages/PrintReceipt.vue'
import PrintReport from '@/pages/PrintReport.vue'
import PrintDailyReport from '@/pages/PrintDailyReport.vue'
import PrintMonthlyReport from '@/pages/PrintMonthlyReport.vue'
import PrintCustomReport from '@/pages/PrintCustomReport.vue'
import PrintLoanContract from '@/pages/PrintLoanContract.vue'


import Calendar from '@/pages/Calendar.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "ការកំណត់ប្រព័ន្ធ",
						component: SettingsView
					}
				]
			},
			{
				path: 'loans',
				component: NewLoan,
				path: 'new_loan'
			},
			{
				path: 'loans',
				component: Loans,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងរំលោះ",
						component: LoansView
					},
					{
						path: 'detail/:hash',
						name: 'ការគ្រប់គ្រងរំលោះ',
						component: LoansDetail
					},
					{
						path: 'edit/:hash',
						name: 'ការគ្រប់គ្រងរំលោះ',
						component: LoansEdit
					},
					{
						path: 'add_principal/:hash',
						name: 'ការគ្រប់គ្រងរំលោះ',
						component: LoansAddPrincipal
					},
					{
						path: 'edit_payment/:hash',
						name: 'ការគ្រប់គ្រងរំលោះ',
						component: LoansEditPayment
					}
				]
			},
			{
				path: 'clients',
				component: Clients,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsView
					},
					{
						path: 'edit/:hash',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsEdit
					},
					{
						path: 'detail/:hash',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsDetail
					}
				]
			},
			{
				path: 'projects',
				component: Projects,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងគម្រោង",
						component: ProjectsView
					},
					{
						path: 'edit/:hash',
						name: "ការគ្រប់គ្រងគម្រោង",
						component: ProjectsEdit
					},
				]
			},
			{
				path: 'transactions',
				component: Transactions,
				children: [
					{
						path: '',
						name: "ប្រវត្តិប្រតិបត្តិការ",
						component: TransactionsView
					}
				]
			},
			{
				path: 'calendar',
				name: "ការទូទាត់ប្រាក់",
				component: Calendar,
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "ការកំណត់គណនី",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'ការកំណត់គណនី',
						component: AdministratorsEdit
					}
				]
			}
		]
	},
	{
		path: '/print_loan/:hash',
		name: "Print Loan",
		component: PrintLoan,
	},
	{
		path: '/print_receipt/:hash',
		name: "Print Receipt",
		component: PrintReceipt,
	},
	{
		path: '/print_loan_contract/:hash',
		name: "Print Loan Contract",
		component: PrintLoanContract,
	},
	{
		path: '/print_report',
		name: "Print Report",
		component: PrintReport,
	},
	{
		path: '/print_daily_report',
		name: "Print Report",
		component: PrintDailyReport,
	},
	{
		path: '/print_monthly_report',
		name: "Print Report",
		component: PrintMonthlyReport,
	},
	{
		path: '/print_custom_report/:start_date/:end_date',
		name: "Print Report",
		component: PrintCustomReport,
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js